export default __webpack_public_path__ + "static/media/get-a-plan.b8425e91.jpg";